import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  "data-testid": "co-writers-tab"
}
const _hoisted_3 = ["href"]

import { checkHasWorkShares } from '../helpers/cookie'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
  isMobile: { type: Boolean, default: false },
},
  setup(__props) {



const userHasWorkShares = checkHasWorkShares()
const dashboardUrl = process.env.VUE_APP_DASHBOARD_URL


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(__props.isMobile ? 'nav-pills is-hidden-above-small' : 'nav-bar sticky is-hidden-below-small'),
    "data-testid": "nav-bar"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'PublishingOverview' } }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("span", null, [
                _createTextVNode("Overview")
              ])), [
                [_directive_translate]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'MyWorks' } }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("span", null, [
                _createTextVNode("My Works")
              ])), [
                [_directive_translate]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'SyncOpportunities' } }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("span", null, [
                _createTextVNode("Sync Opportunities")
              ])), [
                [_directive_translate]
              ])
            ]),
            _: 1
          })
        ]),
        (_unref(userHasWorkShares))
          ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
              _createElementVNode("a", {
                href: `${_unref(dashboardUrl)}/publishing/co-writers`
              }, [
                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                  _createTextVNode("Co-writers")
                ])), [
                  [_directive_translate]
                ])
              ], 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})